
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.133","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.467 8.933a4.534 4.534 0 11-.002 9.068 4.534 4.534 0 01.002-9.068z"}}),_c('path',{attrs:{"d":"M15.487 12.149l-2.195 2.926a.567.567 0 01-.854.061l-1.133-1.133m4.428-7.336V2.133C15.733 1.507 15.226 1 14.6 1H2.133C1.507 1 1 1.507 1 2.133V11.2c0 .626.507 1.133 1.133 1.133h4.534M1 4.4h14.733M3.267 7.233H7.8M3.267 9.5h2.266"}})])])
          )
        }
      }
    